import { ActionType, NextBestActionType, type Action } from '../types';

// Action mapping function
export const getActionMapping = (action: Action) => {
  // Single mapping object for both type and icon
  const actionMapping: Record<
    string,
    {
      type: NextBestActionType;
      icon: string;
      getValue: (action: any) => string;
      getLabel: (action: any) => string;
    }
  > = {
    [ActionType.CallPhone]: {
      type: NextBestActionType.Phone,
      icon: 'Phone',
      getValue: (a) => a.action?.options?.phoneNumber || a.id,
      getLabel: (a) => a.action?.options?.title || a.type,
    },
    [ActionType.SendEmail]: {
      type: NextBestActionType.Email,
      icon: 'EnvelopeSimple',
      getValue: (a) => a.action?.options?.to || a.id,
      getLabel: (a) => a.action?.options?.title || a.type,
    },
    [ActionType.OpenUrl]: {
      type: NextBestActionType.Link,
      icon: 'Link',
      getValue: (a) => a.action?.options?.url || a.id,
      getLabel: (a) => a.action?.options?.title || a.type,
    },
    [ActionType.RunCallback]: {
      type: NextBestActionType.Callback,
      icon: 'Sparkle',
      getValue: (a) => {
        // Return action metadata as JSON string
        return JSON.stringify({
          actionId: a.id,
          searchIntentId: a.searchIntentId,
        });
      },
      getLabel: (a) => a.action?.options?.title || 'Run Action',
    },
    [ActionType.LaunchZendeskChat]: {
      type: NextBestActionType.ZendeskChat,
      icon: 'ChatCircleDots',
      getValue: (a) => a.action?.options?.embedKey || a.id,
      getLabel: (a) => a.action?.options?.title || 'Chat with us',
    },
    [ActionType.LaunchZendeskMessenger]: {
      type: NextBestActionType.ZendeskMessenger,
      icon: 'ChatCircleDots',
      getValue: (a) => a.action?.options?.embedKey || a.id,
      getLabel: (a) => a.action?.options?.title || 'Chat with us',
    },
    [ActionType.LaunchIntercomChat]: {
      type: NextBestActionType.IntercomChat,
      icon: 'ChatCircleDots',
      getValue: (a) => a.action?.options?.appId || a.id,
      getLabel: (a) => a.action?.options?.title || 'Chat with us',
    },
    [ActionType.LaunchFreshdesk]: {
      type: NextBestActionType.Freshdesk,
      icon: 'ChatCircleDots',
      getValue: (a) => a.action?.options?.token || a.id,
      getLabel: (a) => a.action?.options?.title || 'Chat with us',
    },
    [ActionType.LaunchSupportTicketForm]: {
      type: NextBestActionType.Link,
      icon: 'Notepad',
      getValue: (a) => a.action?.options?.formUrl || a.id,
      getLabel: (a) => a.action?.options?.title || 'Submit a ticket',
    },
    [ActionType.LaunchZendeskSunshineChat]: {
      type: NextBestActionType.ZendeskSunshineChat,
      icon: 'CalendarBlank',
      getValue: (a) => {
        return JSON.stringify({
          actionId: a.id,
          requireConfirmation: Boolean(a.action?.options?.requireConfirmation),
        });
      },
      getLabel: (a) => a.action?.options?.title || 'Speak to an expert',
    },
  };

  // Use the mapping with a default fallback
  const mapping = actionMapping[action.type] || {
    type: NextBestActionType.Link,
    icon: 'Link',
    getValue: (a) => a.action?.options?.url || a.id,
    getLabel: (a) => a.action?.options?.title || a.type,
  };

  return mapping;
};
